import DotIcon from "../icons/DotIcon";

function ButtonLabeled({
	label,
	value,
	subvalue = false,
	onClick,
	onDisabledClick = false,
	showInfoHint = false,
	valid = true,
	disabled = false,
	ellipsis = false,
	icon = false,
	vertical = false,
	selected = false,
}) {
	return (
		<button
			className={
				"button-labeled" +
				(disabled ? " disabled" : "") +
				(showInfoHint ? " has-info-hint" : "") +
				(ellipsis ? " ellipsis" : "") +
				(vertical ? " vertical" : "") +
				(selected ? " selected" : "")
			}
			onClick={() => {
				if (disabled) {
					if (onDisabledClick) onDisabledClick();
					return;
				}
				if (onClick) onClick();
			}}
		>
			{icon && <div className="icon">{icon}</div>}
			<div className="info">
				<div className="label">{label}</div>
				<div className="value">{value}<div>{subvalue}</div></div>

				{!valid && (
					<div className="error">
						<div>Richiesto</div>
					</div>
				)}
			</div>
		</button>
	);
}

export default ButtonLabeled;
